import React, { Component } from 'react';
import CameraFill from 'sushiweb/Icons/all/CameraFill';

import './SummaryTable.scss';

class SummaryTable extends Component {

  renderTableContent(ele, index) {
    return (
      <tr key={index}>
        <React.Fragment>
          {
            Object.keys(this.props.modal).map((item, index) => {
              if(item === "quantityDelivered") {
                return (
                  <td key={index} className="table-ele vertical-align-middle">
                    <div className=" gray-text line-through">{`${ele.quantityDispatched} ${ele.measurementUnit}`}</div>
                    <div className="w-600">{`${ele[item]} ${ele.measurementUnit}`}</div>
                  </td>
                )
              } else if( item === "reasonId") {
                return (
                  <td key={index} className="table-ele vertical-align-middle table-ele-content-red">
                    <div>{ele[item]}</div>
                    { ele.images.length !==0 && <div className="flex mt-1">
                      <CameraFill className="icon-color-gray icon-medium mr-1"/>
                      {`${ele.images.length} ${ele.images.length ===1 ? 'Photo' : 'Photos'}`}
                    </div>
                  }
                </td>
                )
              } else {
                return (
                  <td key={index} className="table-ele vertical-align-middle">
                    {ele[item]}
                  </td>
                )
              }             
          })
          }
        </React.Fragment>
      </tr>
    )
  }

  render() {
    const { modal, content, groups } = this.props;
    return (
      <React.Fragment>
        {
          <div className={`table-wrapper ${this.props.className}`}> 
            <table>
              <tbody>
                <tr className="table-header capitalize">
                  {Object.keys(modal).map((ele, index) => {
                    return (
                      <th className={groups && groups[index] ? "table-ele part" : "table-ele"} key={index}>
                        {modal[ele]}
                      </th>
                    )
                  })}
                </tr>
                {content && content.length !== 0 && content.map((ele, index) => this.renderTableContent(ele, index))}
              </tbody>
            </table>
            {!content || content.length === 0 && <div className="no-outlet center warning">No Results Found</div>} 
          </div>
        }
      </React.Fragment>
    )
  }
}

export default SummaryTable;
